import axiosInstance from '@/utils/interceptor'

export interface PoliciesResponse {
  policies: Record<string, boolean>
  defaultService: string | null
}

class PoliciesService {
  // Caches the in-flight/resolved request so repeated calls (e.g. DefaultServiceRedirect
  // remounting on every unmatched-route navigation) reuse one request instead of
  // re-fetching. Cleared on failure so a later call can retry.
  private policiesRequest: Promise<PoliciesResponse> | null = null

  /**
   * Get the current user's policies and recommended default service.
   * GET /authorization/policies
   */
  getPolicies(): Promise<PoliciesResponse> {
    if (!this.policiesRequest) {
      this.policiesRequest = axiosInstance
        .get('authorization/policies')
        .then((response) => response.data)
        .catch((error) => {
          console.warn('Policies request failed; DefaultServiceRedirect will fall back to /reports:', error)
          this.policiesRequest = null
          throw error
        })
    }
    return this.policiesRequest
  }
}

export const policiesService = new PoliciesService()
